import { render, staticRenderFns } from "./Lux.vue?vue&type=template&id=44cc36c7&"
import script from "./Lux.vue?vue&type=script&lang=js&"
export * from "./Lux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports